import { render, staticRenderFns } from "./StudentListManage.vue?vue&type=template&id=6c9e22e4&scoped=true"
import script from "./StudentListManage.vue?vue&type=script&lang=js"
export * from "./StudentListManage.vue?vue&type=script&lang=js"
import style0 from "./StudentListManage.vue?vue&type=style&index=0&id=6c9e22e4&prod&lang=less"
import style1 from "./StudentListManage.vue?vue&type=style&index=1&id=6c9e22e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9e22e4",
  null
  
)

export default component.exports